// extracted by mini-css-extract-plugin
export default {"wrapper":"image-placeholder_wrapper__SvgZY","emptyBox":"image-placeholder_emptyBox__2wYIV"};